import { defineMessages } from "react-intl"

// Lookup lists
export const messages = defineMessages({
  article: {
    id: "resource-type.article",
    defaultMessage: "Article"
  },
  audio: {
    id: "resource-type.audio",
    defaultMessage: "Audio"
  },
  book: {
    id: "resource-type.book",
    defaultMessage: "Book"
  },
  volume: {
    id: "resource-type.bound_volume",
    defaultMessage: "Bound Volume"
  },
  collection: {
    id: "resource-type.collection",
    defaultMessage: "Collection"
  },
  correspondence: {
    id: "resource-type.correspondence",
    defaultMessage: "Correspondence"
  },
  diary: {
    id: "resource-type.diary",
    defaultMessage: "Diary"
  },
  image: {
    id: "resource-type.image",
    defaultMessage: "Image"
  },
  map: {
    id: "resource-type.map",
    defaultMessage: "Map"
  },
  multi_page: {
    id: "resource-type.multi_page",
    defaultMessage: "Multi-Page Document"
  },
  object: {
    id: "resource-type.object",
    defaultMessage: "Object"
  },
  object_image: {
    id: "resource-type.object_image",
    defaultMessage: "Object Image"
  },
  page: {
    id: "resource-type.page",
    defaultMessage: "Page"
  },
  photo_album: {
    id: "resource-type.photo_album",
    defaultMessage: "Photo Album"
  },
  postcard: {
    id: "resource-type.postcard",
    defaultMessage: "Postcard"
  },
  unspecified: {
    id: "resource-type.unspecified",
    defaultMessage: "Unspecified"
  },
  video: {
    id: "resource-type.video",
    defaultMessage: "Video"
  },
  heldInCommunityArchives: {
    id: "held-in.community_archives",
    defaultMessage: "Community Archives"
  },
  heldInCoolstore: {
    id: "held-in.coolstore",
    defaultMessage: "Coolstore"
  },
  heldInImcaDigitalArchive: {
    id: "held-in.imca_digital_archive",
    defaultMessage: "IMCA Digital Archive"
  },
  heldInOther: {
    id: "held-in.other",
    defaultMessage: "Other"
  },
  heldInOutsize: {
    id: "held-in.outsize",
    defaultMessage: "Outsize"
  },
  heldInPncc_archives: {
    id: "held-in.pncc_archives",
    defaultMessage: "PNCC Archives"
  },
  heldInResearch_file: {
    id: "held-in.research_file",
    defaultMessage: "Research File"
  },
  sortUpdatedNewest: {
    id: "sort.updated-newest",
    defaultMessage: "Uploaded Date (Newest)"
  },
  sortUpdatedOldest: {
    id: "sort.updated-oldest",
    defaultMessage:  "Uploaded Date (Oldest)"
  },
  sortRelevance: {
    id: "sort.relevance",
    defaultMessage: "Relevance"
  },
  sortDateNewest: {
    id: "sort.date-newest",
    defaultMessage: "Created Date (Newest)"
  },
  sortDateOldest: {
    id: "sort.date-oldest",
    defaultMessage:  "Created Date (Oldest)"
  },
  fieldNameArchive: {
    id: "field-name.archive",
    defaultMessage: "Archive"
  },
  fieldNameCoverage: {
    id: "field-name.coverage",
    defaultMessage: "Coverage"
  },
  fieldNameCreator: {
    id: "field-name.creator",
    defaultMessage: "Creator"
  },
  fieldNameDigitisationId: {
    id: "field-name.digitisation-id",
    defaultMessage: "Digitisation Id"
  },
  fieldNameDigitisationStatus: {
    id: "field-name.digitisation-status",
    defaultMessage: "Digitisation Status"
  },
  fieldNameLanguage: {
    id: "field-name.language",
    defaultMessage: "Language"
  },
  fieldNameHeldIn: {
    id: "field-name.held-in",
    defaultMessage: "Held In"
  },
  fieldNameOriginalHeldIn: {
    id: "field-name.original-held-in",
    defaultMessage: "Original Held In"
  },
  fieldNameRightsHolder: {
    id: "field-name.rightsholder",
    defaultMessage: "Rightsholder"
  },
  fieldNameTitle: {
    id: "field-name.title",
    defaultMessage: "Title"
  }
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/lists.js